<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.4 17.6957V20.1739C7.4 20.6696 7.72 21 8.2 21H20.2C20.68 21 21 20.6696 21 20.1739V6.54348M3.4 4.06522V16.8696C3.4 17.2826 3.72 17.6957 4.2 17.6957H13.8M13.8 17.6957L17.8 13.5652M13.8 17.6957V13.5652H17.8M17.8 13.5652V4.06522M3 2H18.2"
      class="stroke-current"
    />
    <path
      d="M6 6.37313L7.73395 6H8.22936V10.3284H9.7156V10.9254H6V10.3284H7.48624V6.67164L6 6.97015V6.37313ZM10.7064 10.7015V10.1045C11.2844 10.2537 11.945 10.3284 12.6055 10.403C13.7615 10.403 14.2569 10.0299 14.2569 9.50746C14.2569 8.61194 12.0275 8.46269 10.8716 8.46269L11.0367 6H14.7523V6.59701H11.6972L11.6147 7.9403C13.1835 8.01493 15 8.31343 15 9.50746C15 10.3284 14.2569 11 12.5229 11C11.8624 11 11.2844 10.8507 10.7064 10.7015Z"
      class="fill-current"
    />
  </svg>
</template>
